<template>
  <div class="l-row" v-if="imagesDisabled.length || variation.images.length">
    <form-group :columns="12" label="Imagens" :error="getErrorsBySku('images', variation.sku)">
      <Container :drop="onDrop" @drop="onDrop" orientation="horizontal">
        <Draggable v-model="variation.images" v-if="variation.images.length" v-for="(image, index) in variation.images" :key="image" class="image-list">
          <div class="product-image draggable-item-horizontal">
            <checkbox v-model="index" :checkedDefault="true" :toggleChecked="toggleChecked" class="checkbox-img"/>
            <div class="center-image">
              <img :src="image" alt="">
            </div>
          </div>
        </Draggable>
        <div class="image-list">
          <div v-for="(image, index) in imagesDisabled" :key="image" v-if="imagesDisabled.length" class="product-image disabled">
            <checkbox v-model="index" :checkedDefault="false" :toggleChecked="toggleChecked" class="checkbox-img"/>
            <div class="center-image">
              <img :src="image" alt="">
            </div>
          </div>
        </div>
      </Container>
    </form-group>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Container, Draggable } from 'vue-smooth-dnd'
  import Checkbox from '@/components/template/Checkbox'
  import FormGroup from '@/components/template/FormGroup'

  export default {
    data: () => ({
      imagesDisabled: []
    }),
    props: {
      variation: {
        type: Object,
        required: true
      }
    },
    methods: {
      toggleChecked (selected, index) {
        if (selected) {
          this.variation.images.push(this.imagesDisabled[index])
          this.imagesDisabled.splice(index, 1)
        } else {
          this.imagesDisabled.push(this.variation.images[index])
          this.variation.images.splice(index, 1)
        }
      },
      onDrop (dropResult) {
        this.variation.images = this.applyDrag(this.variation.images, dropResult)
      },
      applyDrag (arr, dragResult) {
        const { removedIndex, addedIndex, payload } = dragResult
        if (removedIndex === null && addedIndex === null) return arr

        const result = [...arr]
        let itemToAdd = payload

        if (removedIndex !== null) {
          itemToAdd = result.splice(removedIndex, 1)[0]
        }

        if (addedIndex !== null) {
          result.splice(addedIndex, 0, itemToAdd)
        }

        return result
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getErrorsBySku'
      ])
    },
    components: {
      FormGroup,
      Checkbox,
      Container,
      Draggable
    }
  }
</script>

<style lang="sass" scoped>
  .smooth-dnd-container
    .image-list
      display: inline-block

      &:not(:first-child)
        margin-left: 6px
        background-color: #FFF

  .product-image
    display: inline-block
    border: 1px solid #333
    padding: 0 10px
    flex-direction: column
    min-height: 100px
    position: relative

    &:not(:first-child)
      margin-left: 10px

    img
      cursor: move
      max-width: 80px

    &.disabled
      border-color: #afafaf

      img
        cursor: not-allowed
        opacity: .2

  .center-image
    height: 100px

    &::before
      content: ''
      display: inline-block
      height: 100%
      vertical-align: middle

  .checkbox-img
    top: 3px
    left: 3px
    position: absolute
</style>



// WEBPACK FOOTER //
// Image.vue?47700619